// Decide se o texto solto (fora de card branco — título/descrição da
// enquete, "X pessoas já responderam" etc.) deve ser escuro ou claro pra
// ler bem contra a cor de fundo personalizada escolhida no admin (ver
// PersonalizarFundoForm.js). Fórmula de luminância relativa (WCAG 2.x):
// calcula o contraste da cor de fundo contra branco e contra preto,
// escolhe o vencedor. Sem cor personalizada (fundo_tipo !== 'cor' — inclui
// imagem, que sempre entra em opacidade baixa sobre o fundo claro padrão),
// retorna null: quem chama já sabe cair pro texto escuro de sempre nesse
// caso, não precisa de nada especial.
function hexParaRgb(hex) {
  const limpo = hex.replace('#', '');
  return {
    r: parseInt(limpo.slice(0, 2), 16),
    g: parseInt(limpo.slice(2, 4), 16),
    b: parseInt(limpo.slice(4, 6), 16)
  };
}

function luminanciaRelativa({ r, g, b }) {
  const canal = (v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * canal(r) + 0.7152 * canal(g) + 0.0722 * canal(b);
}

function contraste(l1, l2) {
  const [claro, escuro] = l1 > l2 ? [l1, l2] : [l2, l1];
  return (claro + 0.05) / (escuro + 0.05);
}

// Não é puro #000/#FFF de propósito — fica mais suave sobre a cor de fundo,
// já garantindo contraste alto o bastante (gray-900/white puro nas duas
// pontas, gray-700/white-85% pro texto secundário).
const TEXTO_ESCURO = { titulo: 'text-gray-900', corpo: 'text-gray-700' };
const TEXTO_CLARO = { titulo: 'text-white', corpo: 'text-white/85' };

export function classesTextoParaFundo(fundoTipo, fundoCor) {
  if (fundoTipo !== 'cor' || !fundoCor) return null;

  const luminanciaFundo = luminanciaRelativa(hexParaRgb(fundoCor));
  const contrasteComPreto = contraste(luminanciaFundo, 0);
  const contrasteComBranco = contraste(luminanciaFundo, 1);

  return contrasteComBranco > contrasteComPreto ? TEXTO_CLARO : TEXTO_ESCURO;
}
